import { messages as portuguese } from './pt-br';
import { messages as english } from './en';

const messages = {
    ...portuguese,
    ...english
}

export { messages }